<div class="card-body">
  <!-- <div class="row" style="justify-content: end;">
    <div (click)="showTableView=true;" style="width: fit-content;" class="btn btn-primary m-1">
      <i style="font-size: 20px;" class="fa fa-table"></i>
    </div>
    <div (click)="showTableView=false;" style="width: fit-content;" class="btn btn-primary m-1">
      <i style="font-size: 20px;" class="fa fa-align-right"></i>
    </div>
  </div> -->
  
  <!-- *ngIf="showTableView" -->
  <table  class="table table-striped">
    <thead class="thead-dark">
      <tr>
        <th scope="col">{{'PersonName' | translate}}</th>
        <th scope="col">{{'Description' | translate}}</th>
        <th scope="col">{{'Timing' | translate}}</th>
        <th scope="col">{{'Attachments' | translate}} </th>
      </tr>
    </thead>
    <tbody>
        <tr
            *ngFor="let item of timelineList ; let i = index">
            <td>{{ item.userFulName }}</td>
            <td>
              {{ item.discription }}
              <p *ngIf="item.discription2!=null&&item.discription2!='undefined'">{{item.discription2 }}</p>
            </td>
            <!-- <td>{{item.discription2!=null&&item.discription2!='undefined' ? item.discription2 : '' }}</td> -->
            <td>{{item.createdOn | toDateTime}}</td>
            <td>
              <a [hidden]="!item.fileName" (click)="download(item);" href="javascript:void(0)">{{item.fileName}}</a>
              <span [hidden]="item.fileName">لا يوجد</span>
            </td>

    </tbody>
  </table>
  <!-- cd-timeline Start-->
  <!-- <section *ngIf="!showTableView" class="cd-container mt-3" id="cd-timeline">
    <div *ngFor="let item of timelineList ; let i = index" class="cd-timeline-block"  >
      <div class="cd-timeline-img cd-picture bg-primary"><i class="fa fa-user-circle"></i></div>
      <div class="cd-timeline-content">
          <h4>{{item.displayName}}</h4>
          <p class="m-0">{{item.discription}}</p>
          <p class="m-0" *ngIf="item.discription2!=null&&item.discription2!='undefined' ">{{item.discription2}}</p>
          <p class="m-0" [hidden]="!item.fileName"><a (click)="download(item);" href="javascript:void(0)">{{item.fileName}}</a></p>
          <span class="cd-date">{{item.createdOn | toDateTime}}</span>
      </div>
    </div>
  </section> -->
</div>
        